import { render, staticRenderFns } from "./df-section-digital-publication.vue?vue&type=template&id=71eaa8ad&"
import script from "./df-section-digital-publication.ts?vue&type=script&lang=ts&"
export * from "./df-section-digital-publication.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports